import React from 'react';
import { H5 } from '../../../../AbstractElements';
import { FormGroup, Input, Label, FormFeedback, Row, Col } from 'reactstrap';
import { getFieldAccess } from '../../../../_helper/fieldAccess';

const AddressInfoForm = ({ formData, errors, handleInputChange, cities, filteredDistricts, handleCityChange, fieldPermissions, canEdit = true }) => {

    const cityAccess = getFieldAccess(fieldPermissions, 'customer.district.city', canEdit);
    const districtAccess = getFieldAccess(fieldPermissions, 'customer.district', canEdit);
    const addressAccess = getFieldAccess(fieldPermissions, 'customer.address', canEdit);
    const handleDistrictChange = (e) => {
        const districtId = e.target.value;
        
        handleInputChange({
            target: {
                name: 'district',
                value: districtId === "" ? null : districtId
            }
        });
    };
    
    return (
        <>
            <H5>Adres Bilgileri</H5>
            <div style={{ height: "20px" }}></div>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label for="city">Şehir {cityAccess.required && <span className="text-danger">*</span>}</Label>
                        <Input
                            type="select"
                            id="city"
                            name="city"
                            value={formData.city || ''}
                            onChange={(e) => handleCityChange(e.target.value)}
                            className={errors.city ? 'is-invalid' : ''}
                            disabled={cityAccess.disabled}
                            required={cityAccess.required}
                        >
                            <option value="">Seçiniz</option>
                            {cities && cities.length > 0 ? 
                                cities.map(city => (
                                    <option key={city.id} value={city.id}>
                                        {city.title}
                                    </option>
                                )) : 
                                <option value="" disabled>Şehir bulunamadı</option>
                            }
                        </Input>
                        <FormFeedback>{errors.city}</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="district">İlçe {districtAccess.required && <span className="text-danger">*</span>}</Label>
                        <Input
                            type="select"
                            id="district"
                            name="district"
                            value={formData.district || ''}
                            onChange={handleDistrictChange}
                            disabled={!formData.city || districtAccess.disabled}
                            required={districtAccess.required}
                            className={errors.district ? 'is-invalid' : ''}
                        >
                            <option value="">Seçiniz</option>
                            {filteredDistricts && filteredDistricts.length > 0 ? 
                                filteredDistricts.map(district => (
                                    <option key={district.id} value={district.id}>
                                        {district.title}
                                    </option>
                                )) : 
                                <option value="" disabled>{formData.city ? 'İlçe bulunamadı' : 'Önce şehir seçiniz'}</option>
                            }
                        </Input>
                        <FormFeedback>{errors.district}</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <FormGroup>
                <Label for="address">Adres {addressAccess.required && <span className="text-danger">*</span>}</Label>
                <Input
                    type="textarea"
                    id="address"
                    name="address"
                    value={formData.address || ''}
                    onChange={handleInputChange}
                    rows={3}
                    invalid={!!errors.address}
                    disabled={addressAccess.disabled}
                    required={addressAccess.required}
                />
                <FormFeedback>{errors.address}</FormFeedback>
            </FormGroup>
        </>
    );
};

export default AddressInfoForm;
